<div class="canvas-style">
  <div class="datepicker">
    <datepicker [(date)]="startDate" class="date"></datepicker>
    <datepicker [(date)]="finDate" class="date"></datepicker>
    <button class="btn btn-sm btn-primary" (click)="staticRdv()">Ok</button>
  </div>

  <!-- Canvas vide + ViewChild -->
  <canvas #consultationsCanvas height="280"></canvas>
</div>
